import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import type { PatchEmailIngestorRequestActionPayload } from 'client/js/redux/domains/EmailIngestor/EmailIngestor.types';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';
import type { EmailIngestor } from '../../../../../../shared/types/roi-hub/fileIngestion.types';

const PatchEmailIngestor = new ReduxAsyncAction<
  'EMAIL_INGESTOR_PATCH',
  PatchEmailIngestorRequestActionPayload,
  EmailIngestor
>('EMAIL_INGESTOR_PATCH');

PatchEmailIngestor.registerRequest(async (payload) => {
  try {
    const { id } = payload;
    const { data } = await dash_api.patch<EmailIngestor>(`/v1/roi/email-ingestor/${id}`, payload);
    NotificationActions.showNotification('Setup complete. Provide your ad partner with email alias', 'success');

    return data;
  } catch (error) {
    NotificationActions.showNotification('Error occurred when setting up email importer', 'error');
    throw error;
  }
});

export const PATCH_EMAIL_INGESTOR = PatchEmailIngestor.actionNamespaceConstants;

export const patchEmailIngestor = PatchEmailIngestor.request;

export type PatchEmailIngestorResponseAction = Action<typeof PATCH_EMAIL_INGESTOR.response> & { data: EmailIngestor };
